import { formattedDate } from '@utils/formattedDate'
import normalizeImage from '@models/Image'

const normalizePostCard = ({
  image,
  category,
  title,
  excerpt,
  date,
  link,
  slug,
  type,
}) => {
  const categoryName = typeof category === 'string' ? category : category?.title || category?.name
  const categorySlug = (category?.slug || categoryName?.toLowerCase()
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '')
    .replace(/[^a-z0-9\s-]/g, '')
    .replace(/\s+/g, '-')
    .replace(/-+/g, '-')) || 'uncategorized'
  
  const normalizedData = {
    image: normalizeImage(image),
    category: categoryName,
    title,
    excerpt,
    date: date ? formattedDate(date) : null,
    link: type
      ? type === 'damage'
        ? `/di-che-ramo-sei/educational-danni/${slug}`
        : `/di-che-ramo-sei/educational-vita/${slug}`
      : `/blog/${categorySlug}/${link ? link : slug}`,
  }

  return normalizedData
}

export default normalizePostCard
